import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'

Vue.use(Router)

export default new Router({
    mode: 'history',
    parseQuery(query) {
        return qs.parse(query, { ignoreQueryPrefix: true });
    },
    stringifyQuery(object) {
        return qs.stringify(object, { addQueryPrefix: true, skipNulls: true });
    }
})



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js